import { styled, SvgIcon as MuiIcon, type SvgIconProps } from '@mui/material';

interface StyledMuiIconProps {
  width?: number | string;
  height?: number | string;
}

const StyledMuiIcon = styled(MuiIcon, {
  shouldForwardProp: (prop) => prop !== 'width' && prop !== 'height' && prop !== 'colorOverwrite',
})<StyledMuiIconProps>(({ ...props }) => ({
  display: 'flex',
  justifySelf: 'center',
  alignSelf: 'center',
  overflow: 'visible',
  width: props.width,
  height: props.height,
}));

export interface IconProps extends SvgIconProps {
  width?: number | string;
  height?: number | string;
}

const SvgIcon = ({
  children,
  width = 10,
  height = 10,
  viewBox,
  color = 'inherit',
  sx,
  ...otherProps
}: IconProps) => {
  return (
    <StyledMuiIcon
      width={width}
      height={height}
      viewBox={viewBox ?? `0 0 ${width} ${height}`}
      sx={sx}
      color={color}
      {...otherProps}
    >
      {children}
    </StyledMuiIcon>
  );
};

export default SvgIcon;
